import { supabase } from '../../lib/supabaseClient';

/**
 * Official "connection confirmed, leave the wizard" mechanism.
 *
 * ROOT CAUSE this exists to fix: connecting Google successfully never
 * flipped Supabase's `needs_onboarding` user_metadata flag (that only
 * happened at the very end of the full /welcome/ready wizard). So even
 * when OAuth + sync worked perfectly, <ProtectedRoute> kept bouncing the
 * user back into /welcome on every reload, and the onboarding steps
 * kept nudging them toward calendar/CRM/automations instead of the real
 * Smart Inbox — which looked exactly like "Google was never connected".
 *
 * This reuses the EXACT mechanism StepReady.js already uses at the end
 * of the full wizard (`supabase.auth.updateUser` + AuthContext refresh)
 * so a real email connection is treated as satisfying the onboarding
 * gate on its own, without introducing a second, divergent way of
 * marking onboarding complete.
 */
export async function finalizeRealConnectionAndEnter({ refresh, navigate, resetOnboarding }) {
  try {
    await supabase.auth.updateUser({ data: { needs_onboarding: false } });
  } catch {
    // Non-blocking: worst case the flag lands a tick late and the user
    // sees one extra bounce through /welcome on a future hard reload —
    // never a loop back into "Conectar Google" for an already-connected
    // account, since /welcome/inbox's own reconciliation would catch it.
  }
  try {
    await refresh?.();
  } catch {
    /* non-blocking */
  }
  try {
    resetOnboarding?.();
  } catch {
    /* ignore */
  }
  navigate('/inbox', { replace: true });
}
